import { ReactNode } from "react";

export type MaintenanceSectionContentProps = {
  children?: ReactNode
}

export const MaintenanceSectionContent = ({ children }: MaintenanceSectionContentProps) => {
  return <div className="w-full">{children}</div>;
};
